import { render } from "./ShopFrom.vue?vue&type=template&id=016386e5&scoped=true"
import script from "./ShopFrom.vue?vue&type=script&lang=js"
export * from "./ShopFrom.vue?vue&type=script&lang=js"

import "./ShopFrom.vue?vue&type=style&index=0&id=016386e5&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016386e5"]])

export default __exports__